/**
 * A placeholder logout component that will now just redirect to the logout page hosted in MAGMA
 *
 * @author Kevin Knielsen <knielsen@alertlogic.com> // The migrator.
 * @author Robert Parker <robert.parker@alertlogic.com> // Blame me.
 * @copyright Alert Logic, Inc 2022
 */

 import { Component, OnInit } from '@angular/core';
 import { AlNavigationService } from '@al/ng-navigation-components';
 import { AlLocation } from '@al/core';

 @Component({
     selector: 'app-logout',
     templateUrl: './logout.component.html'
 })

 export class LogoutComponent implements OnInit {

     constructor(public navigation:AlNavigationService) {
     }

     ngOnInit() {
         this.navigation.navigate.byLocation(AlLocation.MagmaUI, '/#/logout');
     }
 }
